<header>
  <section class="flex flex-row justify-content-between align-items-center h-5 max-w-full m-auto p-4">
    <a (click)="redirect()" class="cursor-pointer" (keypress)="redirect()" tabindex="">
      <img class="w-5rem" alt="visa-logo" loading="lazy" src="https://images.poshvine.com/visa-contactless/visa-logo.png">
    </a>
    <div *ngIf = "isLoggedIn && GlobalConstants.data.login_button_needed" (click)="logout()" (keypress)="logout()" tabindex="">
      <span class="font-semibold text-primary cursor-pointer">Logout</span>
    </div>
  </section>
</header>